/**
 * @generated SignedSource<<ae024417cacf78b5b4e81b8dd1d95a9c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserDetailsRootQuery$variables = {
  key: number;
};
export type UserDetailsRootQuery$data = {
  readonly user: {
    readonly displayName: string | null | undefined;
    readonly key: number;
    readonly name: string | null | undefined;
    readonly ssoUser: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"UserApiKeys_user" | "UserGroups_user" | "UserPasswordSection_user" | "UserProfileSection_user">;
  } | null | undefined;
  readonly whoami: {
    readonly user: {
      readonly key: number;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"AccessControlSettingsPage_query">;
};
export type UserDetailsRootQuery = {
  response: UserDetailsRootQuery$data;
  variables: UserDetailsRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ssoUser",
  "storageKey": null
},
v6 = [
  (v3/*:: as any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v10 = [
  (v9/*:: as any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v16 = [
  {
    "kind": "Literal",
    "name": "filterElement",
    "value": {
      "single": {
        "name": "direct-member",
        "value": "true"
      }
    }
  },
  (v9/*:: as any*/)
],
v17 = [
  (v4/*:: as any*/),
  (v15/*:: as any*/)
],
v18 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": (v10/*:: as any*/),
      "concreteType": "RoleAssignmentConnection",
      "kind": "LinkedField",
      "name": "roleAssignments",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoleAssignmentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleAssignment",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "source",
                  "plural": false,
                  "selections": [
                    (v11/*:: as any*/),
                    (v8/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Role",
                  "kind": "LinkedField",
                  "name": "role",
                  "plural": false,
                  "selections": [
                    (v4/*:: as any*/),
                    (v8/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "target",
                  "plural": false,
                  "selections": [
                    (v11/*:: as any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v2/*:: as any*/)
                      ],
                      "type": "RoleScope",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v17/*:: as any*/),
                      "type": "AccountGroup",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v17/*:: as any*/),
                      "type": "PolicyCollection",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v17/*:: as any*/),
                      "type": "RepositoryConfig",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v17/*:: as any*/),
                      "type": "UserGroup",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v4/*:: as any*/)
                      ],
                      "type": "Repository",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v8/*:: as any*/)
                      ],
                      "type": "Node",
                      "abstractKey": "__isNode"
                    }
                  ],
                  "storageKey": null
                },
                (v8/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "roleAssignments(first:100)"
    }
  ],
  "type": "RolePrincipal",
  "abstractKey": "__isRolePrincipal"
},
v19 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserGroupEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserGroup",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*:: as any*/),
          (v15/*:: as any*/),
          (v4/*:: as any*/),
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userPermissions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "source",
            "plural": false,
            "selections": [
              (v11/*:: as any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isIdentityProvider"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "idpType",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*:: as any*/),
                "type": "CloudOrganization",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "type": "SAMLProvider",
                "abstractKey": null
              },
              (v8/*:: as any*/)
            ],
            "storageKey": null
          },
          (v18/*:: as any*/),
          (v11/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      (v14/*:: as any*/),
      (v13/*:: as any*/),
      (v12/*:: as any*/)
    ],
    "storageKey": null
  }
],
v20 = [
  "filterElement"
],
v21 = [
  {
    "kind": "Literal",
    "name": "filterElement",
    "value": {
      "single": {
        "name": "direct-member",
        "value": "false"
      }
    }
  },
  (v9/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserDetailsRootQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AccessControlSettingsPage_query"
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserApiKeys_user"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserGroups_user"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserPasswordSection_user"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserProfileSection_user"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "whoami",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v6/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "UserDetailsRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "whoami",
        "plural": false,
        "selections": [
          (v7/*:: as any*/),
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UrlConfig",
            "kind": "LinkedField",
            "name": "UrlConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "docs",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          {
            "alias": null,
            "args": (v10/*:: as any*/),
            "concreteType": "APIKeyConnection",
            "kind": "LinkedField",
            "name": "apiKeys",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "problems",
                    "plural": true,
                    "selections": [
                      (v11/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "message",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "Problems",
                "abstractKey": "__isProblems"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "APIKeyEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "APIKey",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "identity",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "expiresAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastUsed",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "revokedAt",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v12/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  },
                  (v13/*:: as any*/),
                  (v14/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "apiKeys(first:100)"
          },
          (v8/*:: as any*/),
          (v15/*:: as any*/),
          {
            "alias": "directGroups",
            "args": (v16/*:: as any*/),
            "concreteType": "UserGroupConnection",
            "kind": "LinkedField",
            "name": "userGroups",
            "plural": false,
            "selections": (v19/*:: as any*/),
            "storageKey": "userGroups(filterElement:{\"single\":{\"name\":\"direct-member\",\"value\":\"true\"}},first:100)"
          },
          {
            "alias": "directGroups",
            "args": (v16/*:: as any*/),
            "filters": (v20/*:: as any*/),
            "handle": "connection",
            "key": "UserGroupsDirect_directGroups",
            "kind": "LinkedHandle",
            "name": "userGroups"
          },
          {
            "alias": "inheritedGroups",
            "args": (v21/*:: as any*/),
            "concreteType": "UserGroupConnection",
            "kind": "LinkedField",
            "name": "userGroups",
            "plural": false,
            "selections": (v19/*:: as any*/),
            "storageKey": "userGroups(filterElement:{\"single\":{\"name\":\"direct-member\",\"value\":\"false\"}},first:100)"
          },
          {
            "alias": "inheritedGroups",
            "args": (v21/*:: as any*/),
            "filters": (v20/*:: as any*/),
            "handle": "connection",
            "key": "UserGroupsInherited_inheritedGroups",
            "kind": "LinkedHandle",
            "name": "userGroups"
          },
          (v7/*:: as any*/),
          (v18/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e2bcc4bf6815f8b33725559bbed58a8b",
    "id": null,
    "metadata": {},
    "name": "UserDetailsRootQuery",
    "operationKind": "query",
    "text": "query UserDetailsRootQuery(\n  $key: Int!\n) {\n  ...AccessControlSettingsPage_query\n  user(key: $key) {\n    displayName\n    key\n    name\n    ssoUser\n    ...UserApiKeys_user\n    ...UserGroups_user\n    ...UserPasswordSection_user\n    ...UserProfileSection_user\n    id\n  }\n  whoami {\n    user {\n      key\n      id\n    }\n  }\n}\n\nfragment AccessControlSettingsPage_query on Query {\n  ...PageWithBreadCrumbs_query\n}\n\nfragment BreadCrumbsHeader_query on Query {\n  whoami {\n    email\n    displayName\n  }\n}\n\nfragment IdentityProviderBadge_source on IdentityProvider {\n  __isIdentityProvider: __typename\n  idpType\n  ... on CloudOrganization {\n    key\n  }\n  ... on SAMLProvider {\n    name\n    displayName\n  }\n}\n\nfragment InlineProblems_problems on Problems {\n  __isProblems: __typename\n  problems {\n    __typename\n    message\n  }\n}\n\nfragment PageWithBreadCrumbs_query on Query {\n  ...BreadCrumbsHeader_query\n}\n\nfragment RoleAssignmentTable_principal on RolePrincipal {\n  __isRolePrincipal: __typename\n  roleAssignments(first: 100) {\n    edges {\n      node {\n        source {\n          __typename\n          id\n        }\n        role {\n          name\n          id\n        }\n        target {\n          __typename\n          ... on RoleScope {\n            displayName\n          }\n          ... on AccountGroup {\n            name\n            uuid\n          }\n          ... on PolicyCollection {\n            name\n            uuid\n          }\n          ... on RepositoryConfig {\n            name\n            uuid\n          }\n          ... on UserGroup {\n            name\n            uuid\n          }\n          ... on Repository {\n            name\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment UserApiKeys_user on User {\n  apiKeys(first: 100) {\n    ...InlineProblems_problems\n    edges {\n      node {\n        id\n        identity\n        description\n        expiresAt\n        lastUsed\n        revokedAt\n      }\n    }\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n      total\n    }\n  }\n  key\n  id\n}\n\nfragment UserGroupCard_group on UserGroup {\n  uuid\n  name\n  displayName\n  userPermissions\n  source {\n    __typename\n    ...IdentityProviderBadge_source\n    id\n  }\n  ...RoleAssignmentTable_principal\n}\n\nfragment UserGroupsDirect_user on User {\n  directGroups: userGroups(first: 100, filterElement: {single: {name: \"direct-member\", value: \"true\"}}) {\n    edges {\n      node {\n        id\n        uuid\n        ...UserGroupCard_group\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      total\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment UserGroupsInherited_user on User {\n  inheritedGroups: userGroups(first: 100, filterElement: {single: {name: \"direct-member\", value: \"false\"}}) {\n    edges {\n      node {\n        id\n        uuid\n        ...UserGroupCard_group\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      total\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment UserGroups_user on User {\n  uuid\n  ...UserGroupsDirect_user\n  ...UserGroupsInherited_user\n}\n\nfragment UserPasswordSection_user on User {\n  displayName\n  key\n  name\n  ssoUser\n}\n\nfragment UserProfileSection_user on User {\n  displayName\n  email\n  ssoUser\n  ...RoleAssignmentTable_principal\n}\n"
  }
};
})();

(node as any).hash = "3068a3cea7674fabeae0420041279491";

export default node;
